import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/**
 * 唯一正式页面头部。
 * - 页面头部：业务图标、单一标题、当前范围（meta）、必要的少量主操作。
 * - 页内视图导航必须进入 navigation 槽，与页面身份同属一个命令面。
 * - 存在 actions（搜索/筛选/刷新/主操作等控制项）时，标题、范围与控制项必须在同一视觉行，且不显示 description 副标题。
 * - 确需保留口径说明的页面（无控制项）可用 description，但内容区不再重复解释。
 */
export function PageHeader({ icon: Icon, title, meta, description, actions, navigation }: {
  icon: LucideIcon;
  title: string;
  meta?: ReactNode;
  description?: string;
  actions?: ReactNode;
  navigation?: ReactNode;
}) {
  const hasActions = Boolean(actions);
  return <header className={`page-header ${hasActions ? "page-header-row" : ""} ${navigation ? "page-header-with-navigation" : ""}`.trim()}>
    <div className="page-header-main">
      <div className="page-header-identity">
        <span className="page-header-icon"><Icon size={hasActions ? 20 : 22} aria-hidden /></span>
        <div className="page-header-title-group">
          <h1>{title}</h1>
          {meta && <div className="page-header-meta">{meta}</div>}
          {!hasActions && description && <p className="page-header-description">{description}</p>}
        </div>
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
    {navigation && <div className="page-header-navigation">{navigation}</div>}
  </header>;
}
